import React, { ReactElement } from 'react';
import { BedRoomSizeName } from '../../types/bedRoom.type';
import { IconBunkBed, IconCribBed, IconOneBed, IconSofaBed, IconTwoBed } from '../../assets/icons';

export const getBedIconByKey = (key: BedRoomSizeName): ReactElement => {
    switch (key) {
        case BedRoomSizeName.BIG_BED:
            return <IconTwoBed />;
        case BedRoomSizeName.NORMAL_BED:
            return <IconOneBed />;
        case BedRoomSizeName.CRIB_BED:
            return <IconCribBed />;
        case BedRoomSizeName.BUNK_BED:
            return <IconBunkBed />;
        case BedRoomSizeName.SOFA_BED:
            return <IconSofaBed />;
        default:
            return <IconOneBed />;
    }
};
